// imports
import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import { IScrollableContainer } from '../../common/types';

// interfaces / types / consts
interface Props {
  fixed?: JSX.Element | undefined;
  children: JSX.Element;
}

// react component
const ScrollableContainer = forwardRef<IScrollableContainer, Props>((props: Props, ref): JSX.Element => {
  const { children, fixed } = props;
  // hooks configuration
  const scrollDivRef = useRef<HTMLDivElement>(null);
  // private methods
  const resetScroll = (): void => {
    if (scrollDivRef.current) {
      scrollDivRef.current.scrollTop = 0;
    }
  };
  const scrollToId = (id: string): void => {
    const scrollableDiv = document.getElementById('scrollable');
    if (scrollableDiv) {
      const targetElement = document.getElementById(id);
      if (targetElement) {
        const containerRect = scrollableDiv.getBoundingClientRect();
        const targetRect = targetElement.getBoundingClientRect();
        const isVisibleInContainer = targetRect.top >= containerRect.top && targetRect.left >= containerRect.left
          && targetRect.bottom <= containerRect.bottom && targetRect.right <= containerRect.right;
        if (!isVisibleInContainer) {
          if (targetRect.bottom > containerRect.bottom) {
            scrollableDiv.scrollTop += targetRect.bottom - containerRect.bottom + 15;
          } else if (targetRect.top < containerRect.top) {
            scrollableDiv.scrollTop -= containerRect.top - targetRect.top + 15;
          }
        }
      }
    }
  };
  useImperativeHandle(ref, () => ({ resetScroll, scrollToId }));
  // render
  return (
    <div className="scrollable-container">
      <div className="page-content-outer">
        <div className="page-content">
          {fixed}
          <div ref={scrollDivRef} className="scrollable" id="scrollable">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
});

// display name
ScrollableContainer.displayName = 'ScrollableContainer';

// exports
export default ScrollableContainer;

// default props
ScrollableContainer.defaultProps = { fixed: undefined };
